import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { data, error } from 'jquery';
import { QRApprovalService } from '../qr-approval.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-approval-dialog',
  templateUrl: './approval-dialog.component.html',
  styleUrls: ['./approval-dialog.component.scss']
})
export class ApprovalDialogComponent implements OnInit {
  assetForm!: FormGroup;
  entityDetails: any;
  ApprovalDetails: any;
  RejectedDetails: any;
  ngOnInit(): void {
    this.assetForm = this.fb.group({
      buildingName: ['', Validators.required],
      poNo: ['', Validators.required],
      majorCategory: ['', Validators.required],
      minorCategory: ['', Validators.required],
      organization: ['', Validators.required],
      blockNo: ['', Validators.required],
      blockName: ['', Validators.required],
      floorNo: ['', Validators.required],
      roomType: ['', Validators.required],
      roomNo: ['', Validators.required],
      noofAssets: ['', Validators.required],
    });
    console.log('PENGIND DATA', this.data);
    this.entityDetails = this.data.entityQRId;
    this.onPatchValue();
  }
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ApprovalDialogComponent>, private fb: FormBuilder, private approval: QRApprovalService, private spinner: NgxSpinnerService,) { }

  onNoClick() {
    this.dialogRef.close();
  }

  onPatchValue() {
    this.assetForm.patchValue({
      buildingName: this.data.buildingName,
      poNo: this.data.assetPoNo,
      majorCategory: this.data.majorCategoryName,
      minorCategory: this.data.minorCategoryName,
      organization: this.data.orgName,
      blockNo: this.data.blockNo,
      blockName: this.data.blockName,
      floorNo: this.data.floorNo,
      roomType: this.data.roomType,
      roomNo: this.data.roomNo,
      noofAssets: this.data.totalAssets
    })
  }
  Approve() {
    const payloadApproval = {
      "entityQrId": this.entityDetails,
      "approveStatus": "APPROVED"
    }
    this.spinner.show();
    this.approval.postApproval(payloadApproval).subscribe(
      {
        next: (res: any) => {
          this.ApprovalDetails = res;
          console.log('ApprovalDetails', this.ApprovalDetails);
          this.spinner.hide();
          this.dialogRef.close('save');
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }

  reject() {
    const payloadrejected = {
      "entityQrId": this.entityDetails,
      "approveStatus": "REJECTED"
    }
    this.spinner.show();
    this.approval.postApproval(payloadrejected).subscribe(
      {
        next: (res: any) => {
          this.RejectedDetails = res;
          console.log('RejectedDetails', this.RejectedDetails);
          this.spinner.hide();
          this.dialogRef.close('save');
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }
}
